import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PlanOptionType} from "@/types/PlansType"
import { http } from "@/utils/http"
import { AxiosResponse } from "axios"
import { PlanOptionFormType } from "@/types/api/plan"
import {
  GET_ADD_OPTIONS_URL,
  GET_UPDATE_DELETE_OPTION_URL,
} from "@/constants/api/endpoints"


// Todo review the response from the update an the create function
interface FetchOptionsParams {
  type?: string;
}
// Fetch all options
export const fetchOptions = createAsyncThunk("option/fetchOptions", async (params:FetchOptionsParams, thunkApi) => {
  return http
    .get<PlanOptionType[]>(GET_ADD_OPTIONS_URL, {params})
    .then((res): PlanOptionType[] => res.data)
    .catch(e => {
      return thunkApi.rejectWithValue({ data: e.data })
    })
})

// Create a option
export const createAsyncOption = createAsyncThunk<PlanOptionType, PlanOptionFormType>(
  "option/createAsyncOption",
  async (option: Partial<PlanOptionFormType>, thunkApi) => {
    return http
      .post<PlanOptionType>(GET_ADD_OPTIONS_URL, option)
      .then((res): PlanOptionType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Update an existing option
export const updateAsyncOption = createAsyncThunk<PlanOptionType, {
  id?: string,
  data?: Partial<PlanOptionFormType | FormData>,
}>(
  "option/updateAsyncOption",
  async ({ id, data }: {
    id?: string,
    data?: Partial<PlanOptionFormType | FormData>,
  }, thunkApi) => {
    return http
      .patch<PlanOptionType>(GET_UPDATE_DELETE_OPTION_URL.replace(":id", `${id}`), data)
      .then((res): PlanOptionType => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)

// Delete an existing option
export const deleteAsyncOption = createAsyncThunk<AxiosResponse, { id: string }>(
  "option/deleteAsyncOption",
  async ({ id }: { id: string }, thunkApi) => {
    return http
      .delete<AxiosResponse>(GET_UPDATE_DELETE_OPTION_URL.replace(":id", id))
      .then(res => res.data)
      .catch(e => {
        return thunkApi.rejectWithValue({ data: e.data })
      })
  },
)


// initial state
const initialState: {
  options: PlanOptionType[],
  optionsStatus: string,
  optionsErrors?: any,

  addOptionStatus: string,
  addOptionErrors?: any,

  deleteOptionErrors?: any,
  deleteOptionStatus: string,
} = {
  options: [],
  optionsStatus: "idle",
  addOptionStatus: "idle",
  deleteOptionStatus: "idle",
}

const optionsSlice = createSlice({
  name: "options",
  initialState,
  reducers: {},

  extraReducers(builder) {
    // get  all options
    builder
      .addCase(fetchOptions.pending, (state) => {
        state.optionsStatus = "loading"
      })
      .addCase(fetchOptions.fulfilled, (state, action) => {
        state.optionsStatus = "succeeded"
        state.options = action.payload
      })
      .addCase(fetchOptions.rejected, (state, action) => {
        state.optionsStatus = "failed"
        state.optionsErrors = action.error
      })

    builder
      .addCase(createAsyncOption.pending, (state) => {
        state.addOptionStatus = "loading"
      })
      .addCase(createAsyncOption.fulfilled, (state, action) => {
        state.addOptionStatus = "succeeded"
        state.options = [action.payload, ...state.options ]

      })
      .addCase(createAsyncOption.rejected, (state, action) => {
        state.addOptionStatus = "failed"
        state.addOptionErrors = action.error
      })

    builder
      .addCase(updateAsyncOption.pending, (state) => {
        state.optionsStatus = "loading"
      })
      .addCase(updateAsyncOption.fulfilled, (state, action) => {
        state.optionsStatus = "succeeded"
        let index = state.options.findIndex(option => option.id === action.meta.arg.id)
        state.options[index] = action.payload

      })
      .addCase(updateAsyncOption.rejected, (state, action) => {
        state.optionsStatus = "failed"
        state.optionsErrors = action.error
      })

    builder
      .addCase(deleteAsyncOption.pending, (state) => {
        state.deleteOptionStatus = "loading"
      })
      .addCase(deleteAsyncOption.fulfilled, (state, action) => {
        state.optionsStatus = "succeeded"
        state.options = state.options.filter((option) => option.id !== action.meta.arg.id)
      })
      .addCase(deleteAsyncOption.rejected, (state, action) => {
        state.deleteOptionStatus = "failed"
        state.deleteOptionErrors = action.error
      })

  },
})

export default optionsSlice.reducer

